/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_In_Info_Edit_DescInputs */

const vi_scl_in_info_edit_desc = /** @type {(inputs: Scl_In_Info_Edit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu đã duyệt chỉ sửa được ngày lấy hương và ghi chú. Lô, khối lượng và lý do nhập giữ nguyên vì đã ghi vào tồn kho.`)
};

/**

* @param {Scl_In_Info_Edit_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_in_info_edit_desc = /** @type {((inputs?: Scl_In_Info_Edit_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_In_Info_Edit_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_in_info_edit_desc(inputs)
});